<template>
    <div
        class="uk-height-1-1 uk-width-1-1 uk-background-primary uk-border-rounded uk-box-shadow-small uk-padding-small graph-container"
    >
        <div class="graph-buttons uk-width-1-1">
            <graph-help :graph-id="id" />
        </div>
        <div class="uk-position-medium uk-position-top-left">
            <span class="uk-text-large uk-text-lead uk-text-bolder">{{ getAggregatedValue }}</span>
            <span
                v-if="difference !== 0"
                class="uk-text-small-number margin-left-small"
                :class="{ 'uk-text-danger': difference < 0, 'uk-text-success': difference > 0 }"
            >
                <i :class="{ 'rotate-135': difference < 0, 'rotate-45': difference > 0 }">
                    <img
                        v-if="difference !== 0"
                        :src="require('@/assets/images/icons/icon-arrow-up.svg')"
                        class="transition-transform"
                        :class="{
                            'rotate-90': difference < 0,
                            'uk-fill-danger': difference < 0,
                        }"
                        uk-svg
                    />
                </i>
                {{ differenceLocal }}%
            </span>
            <span v-else>
                <span class="uk-text-warning margin-left-small"> {{ differenceLocal }}% </span> </span
            ><br />
            <span class="uk-text-meta">{{ title }}</span
            ><br />
        </div>

        <bar-part :chart-data="getChartData" :custom-options="getCustomOptions" :is-time-y-axis="false" />

        <slot />
        <graph-modal :graph-id="id" :title="title" :description="description" />
    </div>
</template>

<script lang="js">
import BarPart from "./graphParts/BarPart.vue";
import GraphsMixin from "@/mixins/graphs-mixin";
import getUnicodeFlagIcon from "country-flag-icons/unicode";
import GraphHelp from "./graphParts/GraphHelp.vue";
import GraphModal from "./graphParts/GraphModal.vue";

export default GraphsMixin.extend({
    name: "FlagGraph",
    components: {
        BarPart,
        GraphHelp,
        GraphModal,
    },
    mixins: [GraphsMixin],
    data() {
        return {
            activeSubmenu: false,
            dataName: "Messages",
        };
    },
    computed: {
        getCustomOptions() {
            const customOptions = {
                plotOptions: {
                    bar: {
                        columnWidth: "12%",
                    },
                },
                xaxis: {
                    labels: {
                        style: {
                            fontSize: "26px",
                        },
                    },
                    offsetY: 0,
                },
                yaxis: {
                    labels: {
                        style: {
                            colors: "#999",
                        },
                    },
                    tickAmount: 1,
                },
                noData: {
                    text: "No Whatsapp data available",
                },
            };

            if (this.chartData.data[0]) {
                const dataEntry = this.chartData.data[0];
                //Set the interval equal to the highest amount of tags used until 6
                if (dataEntry.y < 6) {
                    customOptions.yaxis.tickAmount = dataEntry.y;
                }
            }

            switch (this.chartData.data.length) {
                case this.chartData.data.length < 2:
                    customOptions.plotOptions.bar.columnWidth = "2%";
                    customOptions.xaxis.labels.style.fontSize = "26px";
                    break;
                case this.chartData.data.length < 3:
                    customOptions.plotOptions.bar.columnWidth = "5%";
                    customOptions.xaxis.labels.style.fontSize = "26px";
                    break;
                case this.chartData.data.length < 5:
                    customOptions.plotOptions.bar.columnWidth = "8%";
                    customOptions.xaxis.labels.style.fontSize = "26px";
                    break;
                case this.chartData.data.length < 11:
                    customOptions.plotOptions.bar.columnWidth = "10%";
                    customOptions.xaxis.labels.style.fontSize = "26px";
                    break;
            }

            return customOptions;
        },

        getChartData() {
            this.chartData.data.forEach(function (entry) {
                if (entry.x !== undefined) {
                    entry.x = getUnicodeFlagIcon(entry.x);
                }
            });

            return [this.chartData];
        },
    },
});
</script>
